module.exports = __webpack_public_path__ + "static/media/alumine_jan.64822d60.webp";